import React from 'react'
import './ManuBanner.css'
import manuimg from '../../../../assets/images/manufacture/banner.webp'
import scrollbutton from "../../../../assets/images/manufacture/button.png"

const ManuBanner = () => {
  const scrollToCapabilities = () => {
    const el = document.getElementById('capabilities');
    if (!el) return;

    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="manu">

      {/* Background */}
      <img src={manuimg} alt="" className="manu-bg" />
      <div className="manu-overlay"></div>

      <div className="manu-container">

        {/* TOP TEXT */}
        <div className="manu-top">
          <h1>Manufacture</h1>
          <p>
            Our manufacturing operations are designed to meet the highest pharmaceutical production standards, combining advanced technologies,
            controlled cleanroom environments, and rigorous quality systems. At API, multiple integrated production lines support the manufacturing
            of pharmaceutical and biologic products to serve the growing healthcare needs of Iraq and the region.
          </p>
        </div>

        <div className="manu-highlights">

          <div className="left">
            <h2>Project<br />Highlights</h2>
            <div className="arrow">→</div>
          </div>

          <div className="cards">

            {/* ROW 1 */}
              <div className="empty"></div>
              
            <div className="card">
              <h3>EU-GMP Aligned Facility</h3>
              <p>Designed according to international pharmaceutical manufacturing standards.</p>
            </div>

            <div className="card">
              <h3>Dedicated Manufacturing Buildings</h3>
              <p>Separate production facilities for pharmaceuticals and biologics.</p>
            </div>

            {/* EMPTY SLOT (important for alignment) */}
          

            {/* ROW 2 */}
            <div className="card">
              <h3>Integrated Smart Design</h3>
              <p>Efficient facility layout optimized for production and quality control.</p>
            </div>

            <div className="card">
              <h3>Advanced QA/QC Systems</h3>
              <p>Comprehensive quality assurance and laboratory testing protocols.</p>
            </div>

            <div className="card">
              <h3>Regional Expansion Potential</h3>
              <p>Strategically positioned to support the Iraqi and regional healthcare markets.</p>
            </div>

          </div>

        </div>

        {/* SCROLL ICON */}


      </div>

        <div
          className="scroll"
          role="button"
          tabIndex={0}
          aria-label="Scroll to manufacturing capabilities"
          onClick={scrollToCapabilities}
          onKeyDown={(e) => {
            if (e.key === 'Enter') scrollToCapabilities();
            if (e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              scrollToCapabilities();
            }
          }}
        >
          <img src={scrollbutton} alt="Scroll Down" />
        </div>

    </section>
  )
}

export default ManuBanner